import default_env from "./env.config.default.js";

const production = {
  ...default_env,
  production: true,
  APIURL: "https://admin-backend.instoreview.cl/",
  FRONT_URL: "https://pilotos.instoreview.cl/",
  INSTOREVIEW: "https://instoreview.cl/",
  GS1: "f90d9e8fffcabec799ca87b4a7f0c39928c38db9bb98a3e05b000b9bfe1a400b",
};

export default production;
